import classNames from "classnames"
import { FC } from "react"

interface Props {
  className?: string
  small?: boolean
}

export const Container: FC<Props> = ({ children, className, small }) => (
  <div
    className={classNames(
      "mx-auto px-4 py-8 lg:py-12",
      {
        "max-w-5xl": !small,
        "max-w-2xl": !!small,
      },
      className
    )}
  >
    {children}
  </div>
)
